export default "__VITE_ASSET__stQLp9d5__"